
import React, { useState } from 'react'
import '../../Components/Barbar/styles.css'
import axios from 'axios'
import { toast } from 'react-toastify'
import { useLocation, useNavigate } from 'react-router-dom'
import Header from '../../Components/Header/page'
import Footer from '../../Components/Footer/Footer'
import { Oval } from 'react-loader-spinner'

const Signup = () => {

    const navigate = useNavigate()
    const location = useLocation()

    const [fname, setFname] = useState("")
    const [lname, setLname] = useState("")
    const [Phone, setPhone] = useState("")
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [Loader, setLoader] = useState(false)

    const register = () => {
        try {
            setLoader(true)
            const data = new FormData();
            data.append('fname', fname)
            data.append('lname', lname)
            data.append('phone', Phone)
            data.append('email', email)
            data.append('password', password)
            axios.post(`https://api.kazbarber.com/api/users`, data)
                .then((response) => {
                    console.log(response, "barbar")
                    if (response?.data?.status) {
                        setLoader(false)
                        toast.success('sign up Successfully', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        navigate('/login',{ state: { from: location.pathname } })
                    }
                }).catch((error) => {
                    setLoader(false)
                    toast.error('Something went wrong', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                })

        } catch (error) {
            setLoader(false)
            console.log(error)
            toast.success('something went wrong', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }

    return (
        <>
            <Header />
            <section className='signup'>
                <div className='wrapper'>
                    <h1 className='text-light'>Sign up</h1>
                    <div className="">
                        <input type="text" className='input' placeholder="First Name" onChange={(e) => setFname(e.target.value)} />
                    </div>
                    <div className="">
                        <input type="text" className='input' placeholder="Last Name" onChange={(e) => setLname(e.target.value)} />
                    </div>
                    <div className="">
                        <input type="tel" className='input' placeholder="923773993289" onChange={(e) => setPhone(e.target.value)} />
                        <small className=''>Please include your country code like 92 208368393</small>
                    </div>
                    <div className="">
                        <input type="text" className='input' placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className="">
                        <input type="password" className='input' placeholder="Password" onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    <button type="submit" className="btn-sign" onClick={register}>
                        {Loader ?
                            <Oval
                                ariaLabel="loading-indicator"
                                height={50}
                                width={50}
                                strokeWidth={1}
                                strokeWidthSecondary={2000}
                                color="black"
                                secondaryColor="black"
                                wrapperStyle={{ display: 'flex', justifyContent: "center" }}
                            />
                            :
                            "Sign up"}
                    </button>
                    <p className='text-light'> Already have an account?
                        <a href="/login">Login</a>
                    </p>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default Signup